<template>
  <div class="w-full flex flex-row justify-center mt-8">
    <div class="bg-bkk-50 rounded-full p-1 flex w-fit">
      <button
        :class="[
          ' py-1 rounded-full transition-colors duration-200 text-sm px-10 sm:px-20',
          currentView === CompetitiveChallengeTabType.TAB_INFO
            ? 'bg-white border border-light-gray'
            : 'border-light-gray',
        ]"
        @click="setTab(CompetitiveChallengeTabType.TAB_INFO)"
      >
        {{ t("comp.challenge.started.tab.info.label") }}
      </button>
      <button
        :class="[
          'py-1 rounded-full transition-colors duration-200 text-sm px-10 sm:px-20',
          currentView === CompetitiveChallengeTabType.TAB_TEAM
            ? 'bg-white border border-light-gray'
            : 'border-light-gray',
        ]"
        @click="setTab(CompetitiveChallengeTabType.TAB_TEAM)"
      >
        {{ t("comp.challenge.started.tab.team.label") }}
      </button>

      <button
        :class="[
          'py-1 rounded-full transition-colors duration-200 text-sm px-10 sm:px-20',
          currentView === CompetitiveChallengeTabType.TAB_RANKING
            ? 'bg-white border border-light-gray'
            : 'border-light-gray',
        ]"
        @click="setTab(CompetitiveChallengeTabType.TAB_RANKING)"
      >
        {{ t("comp.challenge.started.tab.ranking.label") }}
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, defineEmits } from "vue";
import { useI18n } from "vue-i18n";
import { CompetitiveChallengeTabType } from "../../../enum/v2/competitive-challenge-tab-type";

const { t } = useI18n();
const emit = defineEmits(["update:currentTab"]);
const currentView = ref<CompetitiveChallengeTabType>(
  CompetitiveChallengeTabType.TAB_TEAM
);

function setTab(tab: CompetitiveChallengeTabType) {
  currentView.value = tab;
  emit("update:currentTab", tab);
}
</script>
